import {ParentSkuMappingItemModel} from './parent-sku-mapping-item.model';
import {PriceInfoModel} from './price-info.model';
import {MetaDataModel} from './meta-data.model';


// item of requestedProductInf.requestedProducts or requestedSupplyInfo.requestedSupplies
// describe notDevice request (which by sku and how much), so to right name should be DeviceRequestItemModel
export class RequestedNotDeviceItemModel {

    // note: if the model is for pagePrice, the this.sku change its meaning... it contains parent device sku instead supply sku
    sku: string;
    amount: number; // contains sum of all parentSkuMapping amounts or amount for NotDevice product
                    // which hasn't parent (nad parentSkuMapping is not defined)

    parentSkuMapping: ParentSkuMappingItemModel[];

    priceInfo: PriceInfoModel;

    connectionTest: number;  // remove just for developing


    pricePerPage: {
        mono: PriceInfoModel;
        color: PriceInfoModel;

    };


    public static toJson(requestedNotDeviceItemModel: RequestedNotDeviceItemModel): RequestedNotDeviceItemModel {
        const requestedNotDeviceItemModelNew: RequestedNotDeviceItemModel = {...requestedNotDeviceItemModel};
        return requestedNotDeviceItemModelNew;
    }

    public static getNewInstance(
        priceInfo = PriceInfoModel.getNewInstance()): RequestedNotDeviceItemModel {

        const result = new RequestedNotDeviceItemModel();
        result.priceInfo = priceInfo;
        result.parentSkuMapping = [];
        return result;
    }


    public static isPagePriceDedicatedSupplyRequest( notDeviceItem: RequestedNotDeviceItemModel): boolean {
        // note: if the model is for pagePrice, the this.sku change its meaning... it contains parent device sku instead supply sku
        // note currently we are not able to recoginzed this state by values in RequestedNotDeviceItemModel itself
        throw Error( 'function is not implemented yet');
    }
}

